import { CanvasHandler } from "../../../handlers";
import store from "../../../redux/store";

class ZoneProperties {
  public canvasHandler: CanvasHandler;
  constructor(canvasHandler: CanvasHandler) {
    this.canvasHandler = canvasHandler;
  }

  public updateProperties = (
    selectedItem: any,
    key: string,
    value: any,
    allValues: any
  ) => {
    const {
      properties: { categories: categoriesList },
    } = store.getState();
    const rows = selectedItem.getObjects("group");
    let selectedCategory: any =
      key === "category"
        ? categoriesList.filter((category: any) => category.key === value)[0]
        : "";
    let shape: any,
      text = null,
      icon = null;
    switch (key) {
      case "textText":
      case "displayedLabelText":
      case "leftText":
      case "topText":
      case "fontSizeText":
      case "fillText":
      case "angleText":
        text = selectedItem.item(1);
        break;
      default:
        console.log("La propiedad no corresponde a un obj texto");
    }

    const activeObject = this.canvasHandler.canvas.getActiveObject();
    let label = selectedItem.item(1);
    // aqui se modifica la propiedad
    switch (key) {
      case "angle":
        selectedItem.rotate(value);
        // selectedItem.addWithUpdate();
        selectedItem.setCoords();
        break;
      case "name":
      case "left":
      case "top":
      case "opacity":
        activeObject.set(key, value);
        activeObject.setCoords();
        break;
      case "height":
      case "width":
        shape.set(key, value);
        shape.setCoords();
        selectedItem.addWithUpdate();
        break;
      case "category":
        selectedItem.set({
          category: {
            name: selectedCategory.name,
            color: selectedCategory.color,
            key: selectedCategory.key,
          },
        });
        const polygon = selectedItem.item(0);
        polygon.set({
          stroke: selectedCategory.color,
          fill: `${selectedCategory.color}40`,
        });

        if (rows.length > 0) {
          rows.forEach((row: any) => {
            row.set({
              category: {
                name: selectedCategory.name,
                color: selectedCategory.color,
                key: selectedCategory.key,
              },
            })
            const seats = row.getObjects("group");
            seats.forEach((seat: any) => {
              const seatShape = seat.item(0);
              seatShape.set({
                stroke: selectedCategory.color,
                fill: `${selectedCategory.color}40`,
              });
              seat.set({
                category: {
                  name: selectedCategory.name,
                  color: selectedCategory.color,
                  key: selectedCategory.key,
                },
              });
            });
          });
        }
        selectedItem.addWithUpdate();
        break;
      case "sectionLabel":
        selectedItem.set({
          section: {
            label: value,
            displayedLabel: selectedItem.section.displayedLabel,
          },
        });
        if (selectedItem.section.displayedLabel === "") {
          label.set({
            text: value
          });
        }
        else {
          label.set({
            text: selectedItem.section.displayedLabel
          });
        }
        if (rows.length > 0) {
          rows.forEach((row: any) => {
            row.set({
              section: {
                label: value,
                displayedLabel: selectedItem.section.displayedLabel,
              },
            })
            const seats = row.getObjects("group");
            seats.forEach((seat: any) => {
              let txtObj = seat.item(1);
              this.setSeatValue(seat, row, txtObj.text);
            });
          });
        }
        break;
      case "displayedSectionLabel":
        selectedItem.set({
          section: {
            label: selectedItem.section.label,
            displayedLabel: value,
          },
        });
        if (rows.length > 0) {
          rows.forEach((row: any) => {
            row.set({
              section: {
                label: selectedItem.section.label,
                displayedLabel: value,
              },
            })
            const seats = row.getObjects("group");
            seats.forEach((seat: any) => {
              let txtObj = seat.item(1);
              this.setSeatValue(seat, row, txtObj.text);
            });
          });
        }
        if (value === "") {
          label.set({
            text: selectedItem.section.label
          });
        }
        else {
          label.set({
            text: value
          });
        }
        break;
      default:
        let newkey: any;

        if (text)
          newkey = key.substring(0, key.length - 4);
        const prop = shape ? shape : text;
        const newNameProperty = shape ? key : newkey;

        prop.set(newNameProperty, value);
        prop.setCoords();
        selectedItem.addWithUpdate();
        break;
    }

    this.canvasHandler.canvas.requestRenderAll();
    const { onModified } = this.canvasHandler;
    if (onModified) onModified(activeObject);
  };

  private setSeatValue = (seat: any, rowData: any, seatlabel: string) => {
    seat.set({
      value: `${rowData.section.label}${rowData.section.label &&
        rowData.row.label &&
        "-"}${rowData.row.label}${(rowData.row.label ||
          rowData.section.label) &&
        seatlabel &&
        "-"}${seatlabel}`,
      isLabeled:
        (rowData.row.enabled ? rowData.row.label != "" : true) &&
        seatlabel != "",
    });
  };
}

export default ZoneProperties;
